module.exports = __webpack_public_path__ + "img/mark.98930f0b.png";